import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import { FixedSizeList as List } from "react-window";
import Select from "react-select";

const CustomMenuList = (props) => {
  const itemHeight = 35;
  const { options, children, maxHeight, getValue } = props;
  const [value] = getValue();

  // Find the index of the current value to scroll to it initially
  const initialOffset = value
    ? options.findIndex((option) => option.value === value.value) * itemHeight
    : 0;

  return (
    <List
      height={Math.min(children.length * itemHeight, maxHeight || 300)}
      itemCount={children.length}
      itemSize={itemHeight}
      initialScrollOffset={Math.max(0, initialOffset)}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

/**
 * Generates a select input form item.
 *
 * @param {string} name                       The name attribute for the input.
 * @param {string} label                      The label for the input.
 * @param {object[]} options                  The options for the select input, each option should have 'value' and 'label'.
 * @param {function} handleChange             The function to call on input change.
 * @param {boolean} [isMulti=false]           Whether the select input allows multiple selections.
 * @param {object|null} [selected=null]       The currently selected option(s), if any.
 * @param {string} [className=""]             Additional class names for the FormGroup wrapper.
 * @param {string} [placeholder="Select..."]  The placeholder text for the select input.
 * @param {boolean} [inFormGroup=true]        Whether to wrap the select in a FormGroup with a label.
 * @return {JSX.Element}                      The form input element.
 */
export function getSelect(
  name,
  options,
  handleChange,
  selected = null,
  className = "",
  placeholder = "Please select..."
) {
  return (
    <FormGroup key={name} className={className}>
      <Select
        options={options}
        id={name}
        name={name}
        value={selected}
        onChange={handleChange}
        className="basic-multi-select"
        classNamePrefix="select"
        placeholder={placeholder}
        components={{ MenuList: CustomMenuList }}
        maxMenuHeight={300}
        isClearable={true}
      />
    </FormGroup>
  );
}

/**
 * Get the input options for a select (idk if it works with other inputs) based
 * on arrays of the values and labels.
 *
 * @param {string[]} choiceValues         Array of values for the options.
 * @param {string[]|null} [choiceLabels]  Array of labels for the options. If not provided,
 *                                        the values will be used as labels.
 * * @return {object[]}                   Array of option objects with 'value' and 'label'.
 */
export function getInputOptions(choiceValues, choiceLabels = null) {
  // Ensure choiceValues is always an array
  const valuesArray = Array.isArray(choiceValues)
    ? choiceValues
    : choiceValues != null
    ? [choiceValues]
    : [];

  if (!choiceLabels) {
    // If no labels provided, use values as labels
    choiceLabels = valuesArray;
  } else {
    // Ensure choiceLabels is also an array
    choiceLabels = Array.isArray(choiceLabels)
      ? choiceLabels
      : choiceLabels != null
      ? [choiceLabels]
      : [];
  }

  var options = valuesArray.map((val, i) => ({
    value: val,
    label: choiceLabels?.[i] ?? val,
  }));

  return options;
}
